import { Component, inject } from '@angular/core';
import { OPEN_GRAPH_SERVICE } from '../../../../../suche-lib/src/lib/services/open-graph.service';
import { LIB_CONFIG } from '../../../../../suche-lib/src/lib/lib.config';
import { OpenGraphService } from '../../service/open-graph.service';

@Component({
  selector: 'now-wbsuche-app-error',
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss'
})
export class ErrorComponent {
  public nowPortalBasePath = inject(LIB_CONFIG).nowPortalBasePath;

  constructor() {
    const openGraphService = inject<OpenGraphService>(OPEN_GRAPH_SERVICE, { optional: true });

    openGraphService?.setDescription(
      'Weiterbildungen suchen und finden - bereitgestellt von einer der größten Weiterbildungsdatenbanken Deutschlands.'
    );
  }
}
